import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducer(agro_exporter_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/new_inspection/${agro_exporter_id}/crop_field`
    );
  },
  fetchCropField(agro_exporter_id, crop_field_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/new_inspection/${agro_exporter_id}/crop_field/${crop_field_id}`
    );
  },
  fetchTemplate({ agro_exporter_id, crop_field_id, quality_template_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/new_inspection/${agro_exporter_id}/${crop_field_id}/quality_template/${quality_template_id}`
    );
  },
  fetchInspectors(agro_exporter_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/new_inspection/${agro_exporter_id}/fetch_inspectors`
    );
  },
  createWithSamplings({
    agro_exporter_id,
    crop_field_id,
    quality_template_id,
    registered_at,
    samplings,
    observations,
    inspect_code,
    inspector_id,
    quality_samplings
  }) {
    return RequesterV1.post(
      `/agro_exporter/quality_control/crop_field/new_inspection/${agro_exporter_id}/crop_field/${crop_field_id}/quality_template/${quality_template_id}/create`,
      {
        quality_inspect: {
          inspect_code,
          registered_at,
          samplings,
          observations,
          inspector_id
        },
        quality_samplings
      }
    );
  },
  createWithoutSamplings({
    agro_exporter_id,
    crop_field_id,
    quality_template_id,
    registered_at,
    observations,
    inspect_code,
    inspector_id,
    quality_generals
  }) {
    return RequesterV1.post(
      `/agro_exporter/quality_control/crop_field/new_inspection/${agro_exporter_id}/crop_field/${crop_field_id}/quality_template/${quality_template_id}/create_without_samplings`,
      {
        quality_inspect: {
          inspect_code,
          registered_at,
          observations,
          inspector_id
        },
        quality_generals
      }
    );
  }
};
